export default "__VITE_ASSET__Dc9cb_Ff__"